import {Pagination} from '../../../utils/pagination'
import {ActivePageHeader} from '../sections/headers/ActivePageHeader'
import ActiveProjectsTable from '../sections/tables/ActiveProjectsTable'
import {ProjectsListPageContext} from '../context/index'
import {useGetBusinessUnitsList} from '../hooks/useGetBusinessUnitsList'
import {useGetProjectsList} from '../hooks/useGetProjectsList'
import useProjectOperations from '../hooks/useProjectOperations'
import usePermission from '../../../hook/usePermission'
import {useSearchParams} from 'react-router-dom'

function Active() {
  const {hasPermission} = usePermission()
  const isActiveProjects = useSearchParams()[0].get('view') === 'active'
  const hasProjectsPermission = hasPermission('projects_all projects', 'write')
  const {
    projectsList,
    isLoading,
    pagination,
    onSearch,
    onPageChange,
    filters,
    searchValue,
    refetchProjectsList,
    onSortingChange,
  } = useGetProjectsList()
  const {businessUnitsList, isLoadingBusinessUnits} = useGetBusinessUnitsList()
  const {
    createNewProjectDetails,
    updateProjectDetails,
    addProjectToFavorite,
    deleteProject,
    isLoading: isOperationLoading,
  } = useProjectOperations()

  const contextValue = {
    hasProjectsPermission,
    isActiveProjects,
    projectsList,
    isLoading,
    isOperationLoading,
    filters,
    businessUnitsList,
    isLoadingBusinessUnits,
    onSearch,
    searchValue,
    updateProjectDetails,
    createNewProjectDetails,
    refetchProjectsList: refetchProjectsList,
    onSortingChange,
    addProjectToFavorite,
    deleteProject,
  }

  return (
    <ProjectsListPageContext.Provider value={contextValue}>
      <ActivePageHeader />
      <ActiveProjectsTable />
      <Pagination pagination={pagination} onPageChange={onPageChange} />
    </ProjectsListPageContext.Provider>
  )
}

export default Active
